import TextField from '@Fields/TextField';
import { splitStringAtFirstOccurrence } from '@Utilities/StringUtils';

class ContactSection extends React.Component {

    static modelToState(props) {
        return {
            Email: props.model.Email,
            EmailOrUsername: props.model.Email,
            ValidatedEmail: props.model.ValidatedEmail,
            Username: props.model.Username,
            VerifyUserName: props.model.VerifyUserName,
            LeadCRMID: props.model.LeadCRMID,
            CRMID: props.model.CRMID,
            ReceiveEmails: props.model.ReceiveEmails,
            ShowWeeklyUpdateSubscriptionCheckbox: props.model.ShowWeeklyUpdateSubscriptionCheckbox,
            FirstName: props.model.FirstName,
            LastName: props.model.LastName,
            Phone: props.model.Phone,
            Company: props.model.Company,
            Password: props.model.Password,
            ReEnterPassword: props.model.ReEnterPassword,
            PrivacyPolicyLink: props.model.PrivacyPolicyLink,
            ClickedForgotPassword: props.model.ClickedForgotPassword,
            EmailIsRegistered: props.model.EmailIsRegistered,
            EmailIsPaidBlock: props.model.EmailIsPaidBlock,
            EmailVerified: false,
            IsRegisteredUser: props.model.IsRegisteredUser,
            CurrentSite: props.model.CurrentSite,
            QueryString: props.masterViewModel.QueryString,
            Translations: props.model.Translations,
            CAPrivacyPolicyNotice: props.model.CAPrivacyPolicyNotice,
            ShowFacebookLoginButton: props.model.ShowFacebookLoginButton,
            ShowGoogleLoginButton: props.model.ShowGoogleLoginButton,
            LocationViewModel: props.model.LocationViewModel,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {},
            UnfinishedLeadNewPartialCRMID: props.model.UnfinishedLeadNewPartialCRMID,
            IsRearrangedDetailsPage: props.masterViewModel.IsRearrangedDetailsPage,
        };
    }

    constructor(props) {
        super(props);

        this.state = ContactSection.modelToState(props);

        this.validatorContact = this.validatorContact.bind(this);
        this.handleFormUpdate = this.handleFormUpdate.bind(this);
        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.submitForm = this.submitForm.bind(this);

        //updates the parent's validator to use this method 
        var masterViewState = this.props.masterViewModel;
        masterViewState.validatorContact = this.validatorContact;
        masterViewState.SaveExitMethod = this.handleButtonClick;
        this.state.IsInTranslationEditorMode = this.props.masterViewModel.IsInTranslationEditorMode;

        // OTP verification
        this.state.EmailForOTPVerification = "";
        this.state.OTPVerificationCode = "";
        this.state.PhoneForOTPVerification = "";
        this.state.AltPhoneForOTPVerification = "";
        this.state.SelectedVerificationMethod = 0;
        this.state.OTPRegistrationLookupSuccess = false;
        this.state.OTPCodeSent = false;
        this.state.ShowOTPForm = false;

        this.props.handleFormUpdate(masterViewState);
    }

    componentWillReceiveProps(nextProps) {
        // Sync ReceiveEmails from parent when it changes externally (e.g., California logic in LocationPickerField)
        if (nextProps.model.ReceiveEmails !== this.state.ReceiveEmails) {
            this.setState({ ReceiveEmails: nextProps.model.ReceiveEmails });
        }
    }

    //will execute AFTER the state has receieved all the props. 
    componentDidMount() {
        var state = this.state;

        //determine what forms to show
        if (state.IsRegisteredUser) {
            this.DisplayLoggedInForm();
        }
        else if (state.EmailIsRegistered) {
            this.DisplayVerifyPasswordForm();
        }
        else {
            if (state.Email != "") {
                //check email format                        
                var bInvalidEmail = false;
                var highlightErrors = state.HighlightErrors;
                var inputErrors = state.InputErrors;

                var atIndex = state.Email.indexOf("@");
                if (atIndex != -1) {
                    var periodIndex = state.Email.indexOf(".", atIndex + 2);
                    if (periodIndex == -1)
                        bInvalidEmail = true;
                }
                else {
                    bInvalidEmail = true;
                }

                if (bInvalidEmail) {
                    highlightErrors.Email = true;
                    inputErrors.Email = this.getTranslation("InvalidFormat");
                    this.setState({
                        HighlightErrors: highlightErrors,
                        InputErrors: inputErrors,
                    }, () => { this.ClearForm(); });
                }
                else {
                    this.IsRegisteredEmail(state.Email, false)
                }
            }
        }

        if (this.props.masterViewModel.IsFacebookLogin || this.props.masterViewModel.IsGoogleLogin) {
            // if the user logged in externally then pull in the contact's info from CRM if we have it
            let xhr = new XMLHttpRequest();
            xhr.onload = function () {
                let response = JSON.parse(xhr.response);
                let oContactViewModel = response.oContactViewModel;
                if (oContactViewModel.CRMID > 0) {
                    // autofill the form input fields
                    state.CRMID = oContactViewModel.CRMID;
                    state.EmailVerified = true;
                    state.Email = oContactViewModel.Email;
                    state.FirstName = oContactViewModel.FirstName;
                    state.LastName = oContactViewModel.LastName;
                    state.Phone = oContactViewModel.Phone;
                    // update location on the master view model (single source of truth)
                    this.updateMasterLocation(oContactViewModel.LocationViewModel);
                    // update the state and XML
                    this.handleFormUpdate(state);
                }
            }.bind(this);
            xhr.open("POST", '/listinginput/ajax/GetContactInfoForExternalLogin' + this.state.QueryString, false);
            xhr.setRequestHeader("Content-type", "application/json");
            xhr.send(JSON.stringify());
        }
    }

    //Handle Form changes
    handleFormUpdate(Model) {
        this.setState({
            Email: Model.Email,
            Username: Model.Username,
            VerifyUserName: Model.VerifyUserName,
            LeadCRMID: Model.LeadCRMID,
            CRMID: Model.CRMID,
            ReceiveEmails: Model.ReceiveEmails,
            ShowWeeklyUpdateSubscriptionCheckbox: Model.ShowWeeklyUpdateSubscriptionCheckbox,
            FirstName: Model.FirstName,
            LastName: Model.LastName,
            Phone: Model.Phone,
            Company: Model.Company,
            Password: Model.Password,
            ReEnterPassword: Model.ReEnterPassword,
            EmailVerified: Model.EmailVerified,
            ClickedForgotPassword: Model.ClickedForgotPassword,
            EmailIsRegistered: Model.EmailIsRegistered,
            EmailIsPaidBlock: Model.EmailIsPaidBlock,
            IsRegisteredUser: Model.IsRegisteredUser,
            QueryString: Model.QueryString,
            Translations: Model.Translations,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors,
            UnfinishedLeadNewPartialCRMID: Model.UnfinishedLeadNewPartialCRMID
        });
    }

    handleMasterUpdate(Model) {
        var masterViewState = this.props.masterViewModel;
        // Preserve LocationViewModel from master since it is managed by LocationPickerField, not ContactSection
        var existingLocation = masterViewState.ContactViewModel && masterViewState.ContactViewModel.LocationViewModel;
        masterViewState.ContactViewModel = Model;
        if (existingLocation) {
            masterViewState.ContactViewModel.LocationViewModel = existingLocation;
        }
        this.props.handleFormUpdate(masterViewState);
    }

    // Read location from the master view model (single source of truth, managed by LocationPickerField)
    getMasterLocation() {
        var masterVM = this.props.masterViewModel;
        return (masterVM.ContactViewModel && masterVM.ContactViewModel.LocationViewModel) || {};
    }

    // Write location updates to the master view model (e.g. after login autofill)
    // Also saves the location to XML so it persists for form submission.
    updateMasterLocation(locationViewModel) {
        var masterViewState = this.props.masterViewModel;
        // Ensure DisplayText is set so validation knows the location was explicitly provided
        if (!locationViewModel.DisplayText && locationViewModel.FormattedLocation) {
            locationViewModel.DisplayText = locationViewModel.FormattedLocation;
        }
        if (masterViewState.ContactViewModel) {
            masterViewState.ContactViewModel.LocationViewModel = locationViewModel;
        }
        this.props.handleFormUpdate(masterViewState);

        // Persist to XML so the server has the updated location
        let xhr = new XMLHttpRequest();
        xhr.open("POST", '/listinginput/Location/ValidateAndSaveLocation', true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify({
            Address: locationViewModel.Address || '',
            City: locationViewModel.City || '',
            State: locationViewModel.State || '',
            PostalCode: locationViewModel.PostalCode || '',
            Country: locationViewModel.Country || '',
            DisplayText: locationViewModel.DisplayText || '',
            CountryShortName: locationViewModel.CountryShortName || '',
            StateShortName: locationViewModel.StateShortName || ''
        }));
    }

    handleFieldChanged(field, value) {
        var state = this.state;
        state[field] = value;

        switch (field) {
            case "Email":
            case "EmailOrUsername":
                state.EmailVerified = false;
                this.setState({
                    Email: value,
                    EmailOrUsername: value
                });
                break;
            case "Password":
                if (value != null && value !== "" && state.InputErrors.Password != null) {
                    state.InputErrors.Password = state.InputErrors.Password.replace(this.getTranslation("CreatePasswordToSave"), "");
                    state.InputErrors.Password = state.InputErrors.Password.replace(this.state.Translations["PasswordInvalid"], "");
                    state.HighlightErrors.Password = false;
                }
                this.PasswordStrength(value);
                this.PasswordMatch(state.Password, state.ReEnterPassword);
                break;
            case "ReceiveEmails":
                this.handleMasterUpdate(state);
                break;
            case "ReEnterPassword":
                this.PasswordMatch(state.Password, state.ReEnterPassword);
                break;
            case "Phone":
                this.handleMasterUpdate(state);
                break;
        }
        this.setState({
            [field]: value,
            EmailVerified: state.EmailVerified,
            InputErrors: state.InputErrors,
            HighlightErrors: state.HighlightErrors
        }, () => {
            if (field === "Password" || field === "ReEnterPassword" || field === "ReceiveEmails") {
                this.handleMasterUpdate(this.state);
            }
        });
    }

    handleButtonClick(btn, mediaOverride = false) {
        var state = this.state;
        switch (btn) {
            case "submit":
                if (pageContainsPlaceholdersForMedia() && !mediaOverride) {
                    MediaOverrideModal();
                }
                else {
                    Spinner.Show($('#pagebody'), true);
                    var that = this;
                    setTimeout(function () {
                        var bNoErrors = that.validatorContact();
                        let checkErrors = () => {
                            if (bNoErrors) {
                                //make sure there is no errors anywhere else in the form
                                if (that.props.masterViewModel.IsLivestock) {
                                    bNoErrors = !(that.props.masterViewModel.validatorLivestockInfo(false));
                                }
                                else if (that.props.masterViewModel.IsCrop) {
                                    bNoErrors = !(that.props.masterViewModel.validatorCropInfo(false));
                                }
                                else {
                                    bNoErrors = that.props.masterViewModel.validatorEquipmentInfo(false);
                                }

                                if (!bNoErrors) {
                                    OpenSpecificHeaderAccordion(EnterInfoSectionID);
                                    Spinner.Remove();
                                }
                            }

                            //validate media section and open if errors
                            if (bNoErrors) {
                                //OpenSpecificHeaderAccordion(MediaSectionID);
                                bNoErrors = that.props.masterViewModel.validatorMedia(false);

                                if (!bNoErrors) {
                                    OpenSpecificHeaderAccordion(MediaSectionID);
                                    Spinner.Remove();
                                }
                            }

                            //validate the consignment section if we need to
                            if (bNoErrors && that.props.masterViewModel.IsConsignment) {
                                //OpenSpecificHeaderAccordion(ConsignmentSectionID);
                                bNoErrors = that.props.masterViewModel.validatorConsignment();

                                if (!bNoErrors) {
                                    OpenSpecificHeaderAccordion(ConsignmentSectionID);
                                    Spinner.Remove();
                                }
                            }

                            if (!state.IsRegisteredUser &&
                                !state.EmailIsRegistered &&
                                !IsNullOrWhiteSpace(state.Email))
                            {
                                state = that.IsRegisteredEmail(state.Email)
                                //the email is now registered and it was not before
                                var xhr = new XMLHttpRequest();
                                xhr.onload = function () {
                                    var response = JSON.parse(xhr.response);
                                    if (!response.bIsActive) {
                                        bNoErrors = false;
                                        window.location = window.location.origin;
                                    }
                                    else {
                                        if (!$('#ContactLocationInfo').is(":visible") && !$("#submit-section").is(":visible")) {
                                            bNoErrors = false;
                                            Spinner.Remove();
                                        }
                                    }
                                }.bind(this);

                                xhr.open("POST", '/listinginput/details/IsWTAPActive' + state.QueryString, false);
                                xhr.setRequestHeader("Content-type", "application/json");
                                xhr.send(JSON.stringify(state));
                            }

                            if (bNoErrors) {
                                //if no errors, move on to account creation/submission
                                //submit listing if signed in.
                                if (state.IsRegisteredUser || state.EmailVerified) {
                                    that.props.SaveAllSections();
                                    //we don't need to check bAddressChanged (even if they've changed it) because we check the address above
                                    that.props.submitListing();
                                }
                                else {
                                    //create account. This is done in a Javascript file so that recaptch can be used. Recaptcha needs to call a javascript method and cannot communicate with react states.
                                    that.submitForm(null);
                                }
                            }
                            else {
                                Spinner.Remove();
                            }
                        };

                        //if this person is a lead then we need to try and promote them to be a contact
                        if (state.LeadCRMID > 0 && state.CRMID <= 0) {
                            var ContactViewModel = {
                                LeadCRMID: state.LeadCRMID,
                                Email: state.Email,
                                FirstName: state.FirstName,
                                LastName: state.LastName,
                                Phone: state.Phone,
                                Company: state.Company,
                                LocationViewModel: that.getMasterLocation(),
                            }

                            var xhr = new XMLHttpRequest();
                            xhr.onload = function () {
                                var response = JSON.parse(xhr.response);
                                if (!response.bSuccess) {
                                    bNoErrors = false;
                                    if (response.sMessage !== null) {
                                        let inputErrors = {};
                                        inputErrors.LeadPromotion = response.sMessage;
                                        that.setState({
                                            InputErrors: inputErrors,
                                        });
                                    }
                                    checkErrors();
                                    return false;
                                }
                                checkErrors();
                            }.bind(this);

                            xhr.open("POST", '/listinginput/registration/TryPromoteLead' + state.QueryString, false);
                            xhr.setRequestHeader("Content-type", "application/json");
                            xhr.send(JSON.stringify(ContactViewModel));
                        }
                        else {
                            checkErrors();
                        }
                    }, 100);
                }
                break;
            case "login":
                this.validateEmailPasswordCombo(state);
                break;
            case "reset":
                state.ClickedForgotPassword = true;
                this.handleFormUpdate(state);
                ResetPassword(state);
                break;
            case "exitVerify":
                Spinner.Show($('#pagebody'), true);

                if (state.VerifyUserName) {
                    //timeout allows for the spinner to show slightly, gives user a visualy that the button click worked.
                    if (!state.Password) {
                        Spinner.Remove();

                        state.HighlightErrors.Password = true;
                        state.InputErrors.Password = this.state.Translations["IncorrectCredentials"];
                        this.handleFormUpdate(state);

                        return false;
                    }

                    var objectToSend = {
                        Email: state.Email,
                        Username: state.Username,
                        Password: state.Password,
                    };

                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                        var response = JSON.parse(xhr.response);

                        if (response.oContactModel.EmailIsPaidBlock) {
                            state.HighlightErrors.Password = true;
                            state.InputErrors.Password = this.state.Translations["IncorrectCredentials"];
                            this.handleFormUpdate(state);

                            return false;
                        }
                        //if we found a contact that has matching username, pwd, then use that as our login values
                        else if (response.oContactModel.CRMID > 0) {

                            //autofill the input fields
                            state.EmailVerified = true;
                            state.Email = response.oContactModel.Email;
                            state.FirstName = response.oContactModel.FirstName;
                            state.LastName = response.oContactModel.LastName;
                            state.Phone = response.oContactModel.Phone;
                            state.HighlightErrors.Password = false;
                            state.InputErrors.Password = "";

                            this.updateMasterLocation(response.oContactModel.LocationViewModel);
                            this.handleFormUpdate(state);

                            //we've successfully verified password. Go home
                            window.location = response.oContactModel.NextPageURL;
                        }
                        //the login was invalid, so show them that
                        else {
                            Spinner.Remove();

                            state.HighlightErrors.Password = true;
                            state.InputErrors.Password = this.state.Translations["PasswordInvalid"];
                            this.handleFormUpdate(state);

                            return false;
                        }
                    }.bind(this);

                    xhr.open("POST", '/listinginput/registration/VerifyUsernamePasswordCombo' + this.state.QueryString, false);
                    xhr.setRequestHeader("Content-type", "application/json");
                    xhr.send(JSON.stringify(objectToSend));
                }
                else {
                    //timeout allows for the spinner to show slightly, gives user a visualy that the button click worked.
                    if (!state.Password) {
                        Spinner.Remove();

                        state.HighlightErrors.Password = true;
                        state.InputErrors.Password = this.state.Translations["IncorrectCredentials"];
                        this.handleFormUpdate(state);

                        return false;
                    }

                    var objectToSend = {
                        Email: state.Email,
                        Password: state.Password,
                    };

                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                        var response = JSON.parse(xhr.response);

                        if (response.oContactModel.VerifyUserName) {
                            Spinner.Remove();
                            state.VerifyUserName = true;
                            state.HighlightErrors.Password = false;
                            state.InputErrors.Password = "";
                            this.handleFormUpdate(state);

                            $('.Username').fadeIn();
                            return false;
                        }
                        else if (response.oContactModel.EmailIsPaidBlock) {
                            Spinner.Remove();

                            state.HighlightErrors.Password = true;
                            state.InputErrors.Password = this.state.Translations["IncorrectCredentials"];
                            this.handleFormUpdate(state);
                            $("#Password-Input").focus();

                            return false;
                        }
                        else if (response.oContactModel.CRMID > 0) {

                            //autofill the input fields
                            state.EmailVerified = true;
                            state.Email = response.oContactModel.Email;
                            state.FirstName = response.oContactModel.FirstName;
                            state.LastName = response.oContactModel.LastName;
                            state.Phone = response.oContactModel.Phone;
                            state.HighlightErrors.Password = false;
                            state.InputErrors.Password = "";

                            this.updateMasterLocation(response.oContactModel.LocationViewModel);
                            this.handleFormUpdate(state);

                            //we've successfully verified password. Go home
                            window.location = response.oContactModel.NextPageURL;
                        }
                        else {
                            Spinner.Remove();

                            state.HighlightErrors.Password = true;
                            state.InputErrors.Password = this.state.Translations["PasswordInvalid"];
                            this.handleFormUpdate(state);
                            setTimeout(() => {
                                const passwordInput = document.getElementById("Password-Input");
                                if (passwordInput) {
                                    passwordInput.focus();
                                }
                            }, 0);

                            return false;
                        }
                    }.bind(this);

                    xhr.open("POST", '/listinginput/registration/VerifyEmailPasswordCombo' + this.state.QueryString, false);
                    xhr.setRequestHeader("Content-type", "application/json");
                    xhr.send(JSON.stringify(objectToSend));
                }
                break;
            case "exitNewUser":
                Spinner.Show($('#pagebody'), true);

                var bNoErrors = this.validatorContact(null, true);

                //if no errors in contact section, move on to account creation before the exit
                if (bNoErrors) {
                    this.setState({
                        bIsExitNewUser: true
                    }, function () {
                        this.submitForm(null);
                    });

                }
                else {
                    Spinner.Remove();
                }
                break;
            case "SuggestedEmail":
                delete state.HighlightErrors["Email"];
                delete state.InputErrors["Email"];

                var suggestedEmail = $('#emailSuggestion').val();
                $('#emailSuggestionWrapper').hide();
                state.Email = suggestedEmail;
                this.handleFormUpdate(state);

                //Added new event for handle on blur 
                var e = {};
                e.target = {};
                e.target.value = state.Email;
                this.handleOnBlur("Email", e);
                break;
            case "SearchRegistrationForOTPVerification":
                Spinner.Show($('#pagebody'), true);
                var objectToSend = {
                    EmailOrUsername: state.EmailOrUsername
                };

                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    Spinner.Remove();
                    var response = JSON.parse(xhr.response);
                    state.HighlightErrors.EmailOrUsername = !response.oVerificationModel.RegistrationLookupSuccess;
                    state.InputErrors.EmailOrUsername = response.oVerificationModel.ErrorMessage;
                    this.setState({
                        EmailForOTPVerification: response.oVerificationModel.Email,
                        PhoneForOTPVerification: response.oVerificationModel.PhoneEnding4Digits,
                        AltPhoneForOTPVerification: response.oVerificationModel.AltPhoneEnding4Digits,
                        OTPRegistrationLookupSuccess: response.oVerificationModel.RegistrationLookupSuccess,
                        OTPCodeSent: false,
                        ValidOTPCode: false,
                        InputErrors: state.InputErrors,
                        HighlightErrors: state.HighlightErrors
                    });
                    setTimeout(() => {
                        const sendCode = document.getElementById("send-code-btn");
                        if (sendCode) {
                            sendCode.focus();
                        }
                    }, 0);
                }.bind(this);

                xhr.open("POST", '/listinginput/registration/SearchRegistrationForOTPVerification' + this.state.QueryString, false);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToSend));
                break;
            case "SendCodeForOTPVerification":
                Spinner.Show($('#pagebody'), true);
                var objectToSend = {
                    Email: state.EmailForOTPVerification,
                    PhoneEnding4Digits: state.PhoneForOTPVerification,
                    AltPhoneEnding4Digits: state.AltPhoneForOTPVerification,
                    SelectedVerificationMethod: state.SelectedVerificationMethod
                };

                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    Spinner.Remove();
                    var response = JSON.parse(xhr.response);
                    state.HighlightErrors.EmailOrUsername = !response.oVerificationModel.RegistrationLookupSuccess;
                    state.InputErrors.EmailOrUsername = response.oVerificationModel.ErrorMessage;
                    if (response.oVerificationModel.CodeSent) {
                        state.InputErrors.OTPVerificationCode = response.oVerificationModel.ErrorMessage;
                    }
                    this.setState({
                        OTPCodeSent: response.oVerificationModel.CodeSent,
                        ValidOTPCode: false,
                        InputErrors: state.InputErrors,
                        HighlightErrors: state.HighlightErrors
                    });
                    setTimeout(() => {
                        const verificationCode = document.getElementById("Verification-Code");
                        if (verificationCode) {
                            verificationCode.focus();
                        }
                    }, 0);
                }.bind(this);

                xhr.open("POST", '/listinginput/registration/SendCodeForOTPVerification' + this.state.QueryString, false);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToSend));
                break;
            case "ValidateCodeForOTPVerification":
                Spinner.Show($('#pagebody'), true);

                var objectToSend = {
                    VerificationCode: state.OTPVerificationCode,
                    Email: state.EmailForOTPVerification
                };

                var that = this;

                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    Spinner.Remove();
                    var response = JSON.parse(xhr.response);
                    state.HighlightErrors.OTPVerificationCode = !response.oVerificationModel.ValidCode;
                    state.InputErrors.OTPVerificationCode = response.oVerificationModel.ErrorMessage;
                    if (response.oVerificationModel.ValidCode && response.oContactModel.CRMID > 0) {
                        //autofill the input fields
                        state.CRMID = response.oContactModel.CRMID;
                        state.EmailVerified = true;
                        state.IsRegisteredUser = true;
                        state.Email = response.oContactModel.Email;
                        state.FirstName = response.oContactModel.FirstName;
                        state.LastName = response.oContactModel.LastName;
                        state.Phone = response.oContactModel.Phone;

                        // clear errors
                        state.HighlightErrors.Email = false;
                        state.InputErrors.Email = "";
                        state.HighlightErrors.FirstName = false;
                        state.HighlightErrors.LastName = false;
                        state.InputErrors.Name = "";
                        state.HighlightErrors.Phone = false;
                        state.InputErrors.Phone = "";
                        state.HighlightErrors.Password = false;
                        state.InputErrors.Password = "";

                        that.updateMasterLocation(response.oContactModel.LocationViewModel);
                        that.handleFormUpdate(state);
                        that.handleMasterUpdate(state);

                        $('#ContactLocationInfo').fadeIn();
                        $('#contact-phone').fadeIn();
                        $('#contact-name').fadeIn();
                        $('#SubmitBtn').fadeIn();
                        $('#CreateAccountSection').hide();
                        $('#VerifyPasswordSection').hide();
                        $('#VerifyPasswordSaveAndExit').hide();
                        $("#saveExitMessage").hide();
                        $('#contact-email').hide();
                        if (that.state.IsRearrangedDetailsPage) {
                            $("#info-done-contact-btn").focus();
                        } else {
                            $("#submit-btn").focus();
                            $("#submit-section").hide();
                        }
                        $('#OTPVerificationForm').hide();
                        $("#info-done-contact-btn").show();
                        that.setState({
                            ShowOTPForm: false
                        });
                        let tagetElement = this.state.IsRearrangedSite ? document.getElementById("info-done-contact-btn") : document.getElementById("submit-btn");
                        setTimeout(() => {
                            if (tagetElement) {
                                tagetElement.focus();
                            }
                        }, 0);
                    } else {
                        setTimeout(() => {
                            const verificationCode = document.getElementById("Verification-Code");
                            if (verificationCode) {
                                verificationCode.focus();
                            }
                        }, 0);
                    }
                    that.setState({
                        InputErrors: state.InputErrors,
                        HighlightErrors: state.HighlightErrors
                    });
                }.bind(that);

                xhr.open("POST", '/listinginput/registration/ValidateCodeForOTPVerification' + this.state.QueryString, false);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToSend));
                break;
            case "done":
                let noErrors = this.validatorContact(null, null, true);
                if (noErrors) {
                    if (this.state.CurrentSite === "MarketBook") {
                        OpenSpecificHeaderAccordion(MediaSectionID);
                        setTimeout(() => {
                            const serialVIN = document.getElementById("dropbox");
                            if (serialVIN) {
                                serialVIN.focus();
                            }
                        }, 0);
                    } else {
                        OpenSpecificHeaderAccordion(EnterInfoSectionID);
                        setTimeout(() => {
                            const serialVIN = document.getElementById("SerialVIN");
                            if (serialVIN) {
                                serialVIN.focus();
                            }
                        }, 0);
                    }
                }
                break;
        }
    }


    handleOnBlur(field, e) {
        var state = this.state;
        var value = e.target.value;
        var highlightErrors = state.HighlightErrors;
        var inputErrors = state.InputErrors;

        //Hide reset password messages, when switching emails
        $('#ResetPasswordEmailSuccess').hide()
        $('#ResetPasswordEmailError').hide()

        switch (field) {
            case "Email":
                //check if user is registered
                if (!state.IsRegisteredUser && !state.EmailVerified) {
                    if (IsNullOrWhiteSpace(state.Email)) {
                        this.ClearForm();
                        $("#info-done-contact-btn").show();
                    }
                    else {
                        //prevent on blur events if email doesn't change and update ValidatedEmail
                        if (state.Email != state.ValidatedEmail) {
                            state.ValidatedEmail = state.Email;

                            //check email format                        
                            var bInvalidEmail = false;

                            var atIndex = state.Email.indexOf("@");
                            if (atIndex != -1) {
                                var periodIndex = state.Email.indexOf(".", atIndex + 2);
                                if (periodIndex == -1)
                                    bInvalidEmail = true;
                            }
                            else {
                                bInvalidEmail = true;
                            }

                            if (bInvalidEmail) {
                                highlightErrors.Email = true;
                                inputErrors.Email = this.getTranslation("InvalidFormat");
                                this.setState({
                                    HighlightErrors: highlightErrors,
                                    InputErrors: inputErrors,
                                }, () => { this.ClearForm(); $("#info-done-contact-btn").show();  });
                            }
                            else {
                                var model;
                                state = this.IsRegisteredEmail(state.Email)
                                if (state.EmailIsRegistered == false) {
                                    model = this.IsValidEmail(state.Email);

                                    if (model.IsValidEmail == false) {
                                        highlightErrors.Email = true;
                                        inputErrors.Email = this.getTranslation("InvalidEmail");
                                        this.setState({
                                            HighlightErrors: highlightErrors,
                                            InputErrors: inputErrors,
                                            ValidatedEmail: state.Email,
                                        }, () => { this.ClearForm(); });
                                    }
                                }
                                Spinner.Remove();
                            }
                        }
                    }
                }
                break;
            default:
                break;
        }

        state[field] = value;
        this.setState({
            [field]: value,
        });

        this.handleMasterUpdate(state);
    }

    //Methods
    validatorContact(state, bRequirePassword, skipLocationValidation) {
        state = state || this.state;
        let bHasErrors = false;
        let formErrors = [];
        let highlightErrors = {};
        let inputErrors = {};
        let bFirstError = true;
        let firstErrorElement;

        //check required fields
        if (!state.IsRegisteredUser && !state.EmailVerified) {
            if (IsNullOrWhiteSpace(state.Email)) {
                highlightErrors.Email = true;
                inputErrors.Email = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Email"]);
                if (bFirstError) {
                    bFirstError = false;
                    firstErrorElement = $('input[id="Email"]');
                }
            }
        }

        if (IsNullOrWhiteSpace(state.FirstName)) {
            highlightErrors.FirstName = true;
            inputErrors.Name = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Name"]);
            if (bFirstError) {
                bFirstError = false;
                firstErrorElement = $('input[id="FirstName"]');
            }
        }
        if (IsNullOrWhiteSpace(state.LastName)) {
            highlightErrors.LastName = true;
            inputErrors.Name = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Name"]);
            if (bFirstError) {
                bFirstError = false;
                firstErrorElement = $('input[id="LastName"]');
            }
        }
        if (IsNullOrWhiteSpace(state.Phone)) {
            highlightErrors.Phone = true;
            inputErrors.Phone = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Phone"]);
            if (bFirstError) {
                bFirstError = false;
                firstErrorElement = $('input[id="Phone"]');
            }
        }
        if (state.Password != state.ReEnterPassword && !state.IsRegisteredUser && !state.EmailIsRegistered) {
            highlightErrors.ReEnterPassword = true;
        }
        if (bRequirePassword && IsNullOrWhiteSpace(state.Password)) {
            // a new user trying to save and exit will need to create an account
            highlightErrors.Password = true;
            inputErrors.Password = this.getTranslation("CreatePasswordToSave");
        }

        //check if there is any errors, if not, validate location details
        // don't validate location here if its a rearranged site
        bHasErrors = Object.keys(inputErrors).length != 0;
        if (!bHasErrors &&
            (skipLocationValidation == null || !skipLocationValidation)) {
            // Read location from the master view model to ensure we have the latest data
            var masterLocationVM = this.getMasterLocation();
            var objectToSend = {
                Address: masterLocationVM.Address || '',
                City: masterLocationVM.City || '',
                State: masterLocationVM.State || '',
                PostalCode: masterLocationVM.PostalCode || '',
                Country: masterLocationVM.Country || '',
                DisplayText: masterLocationVM.DisplayText || '',
                CountryShortName: masterLocationVM.CountryShortName || '',
                StateShortName: masterLocationVM.StateShortName || '',
            };

            // Validate only — don't re-save to XML. The location was already saved
            // by LocationPickerField when the user selected it.
            var xhr = new XMLHttpRequest();
            xhr.open("POST", '/listinginput/Location/ValidateAndSaveLocation', false);
            xhr.setRequestHeader("Content-type", "application/json");
            xhr.send(JSON.stringify(objectToSend));

            if (xhr.status === 200) {
                var response = JSON.parse(xhr.response);
                if (response.error) {
                    bHasErrors = true;
                    highlightErrors.LocationPicker = true;
                    if (bFirstError) {
                        bFirstError = false;
                        firstErrorElement = $('input[id="LocationPicker"]');
                    }
                    if (response.error === "locationRequired") {
                        inputErrors.LocationPicker = state.Translations["IsRequired"].replace("{0}", state.Translations["Location"]);
                    } else {
                        inputErrors.LocationPicker = response.error;
                    }
                } else {
                    delete highlightErrors.LocationPicker;
                    delete inputErrors.LocationPicker;
                }
            }
        }

        //save details to xml if there is no errors
        if (!bHasErrors) {
            //clear errors on the page
            this.setState({
                HighlightErrors: highlightErrors,
                InputErrors: inputErrors,
                FormErrors: formErrors,
            });

            return true;
        }
        else {
            if (this.state.IsRearrangedDetailsPage) {
                OpenSpecificHeaderAccordion(ContactSectionID);
            }

            if (!!(firstErrorElement)) {
                ScrollToElement(firstErrorElement);
            }

            this.setState({
                HighlightErrors: highlightErrors,
                InputErrors: inputErrors,
                FormErrors: formErrors,
            });

            return false;
        }
    }

    validateEmailPasswordCombo(state) {
        if (IsNullOrWhiteSpace(state.Password)) {
            state.HighlightErrors.Password = true;
            state.InputErrors.Password = this.state.Translations["PasswordInvalid"];
            this.handleFormUpdate(state);
        }
        else if (state.VerifyUserName) {
            if (IsNullOrWhiteSpace(state.Username)) {
                state.HighlightErrors.Password = true;
                state.InputErrors.Password = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Username"]);
                this.handleFormUpdate(state);
            }
            else {
                Spinner.Show($('#pagebody'), true);
                var that = this;

                //timeout allows for the spinner to show slightly, gives user a visual that the button click worked.
                var objectToSend = {
                    Email: state.Email,
                    Username: state.Username,
                    Password: state.Password,
                };

                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    var response = JSON.parse(xhr.response);
                    Spinner.Remove();

                    if (response.oContactModel.EmailIsPaidBlock) {
                        state.HighlightErrors.Password = true;
                        state.InputErrors.Password = that.state.Translations["IncorrectCredentials"];
                        that.handleFormUpdate(state);

                        return false;
                    }
                    else if (response.nPasswordResetStatusID == 2) {
                        that.DisplayVerifyPasswordForm();
                        state.HighlightErrors.Email = true;
                        state.InputErrors.Email = state.Translations["TemporaryPasswordUsed"];
                        $('input[id="Password-Input"]').focus();
                    }
                    else if (response.oContactModel.CRMID > 0) {
                        //autofill the input fields
                        state.CRMID = response.oContactModel.CRMID;
                        state.EmailVerified = true;
                        state.Email = response.oContactModel.Email;
                        state.FirstName = response.oContactModel.FirstName;
                        state.LastName = response.oContactModel.LastName;
                        state.Phone = response.oContactModel.Phone;

                        // clear errors
                        state.HighlightErrors.Email = false;
                        state.InputErrors.Email = "";
                        state.HighlightErrors.FirstName = false;
                        state.HighlightErrors.LastName = false;
                        state.InputErrors.Name = "";
                        state.HighlightErrors.Phone = false;
                        state.InputErrors.Phone = "";
                        state.HighlightErrors.Password = false;
                        state.InputErrors.Password = "";

                        that.updateMasterLocation(response.oContactModel.LocationViewModel);
                        that.handleFormUpdate(state);
                        that.handleMasterUpdate(state);

                        $('#ContactLocationInfo').fadeIn();
                        $('#contact-phone').fadeIn();
                        $('#contact-name').fadeIn();
                        $('#SubmitBtn').fadeIn();
                        $('#CreateAccountSection').hide();
                        $('#VerifyPasswordSection').hide();
                        $('#VerifyPasswordSaveAndExit').hide();
                        $("#saveExitMessage").hide();
                        $("#SavedFor30Days").hide();
                        $('#contact-email').hide();
                        if (!that.state.IsRearrangedDetailsPage) {
                            $("#submit-section").hide();
                        }
                        $("#info-done-contact-btn").show();

                        return true;
                    }
                    else {
                        state.HighlightErrors.Password = true;
                        state.InputErrors.Password = that.state.Translations["PasswordInvalid"];
                        that.handleFormUpdate(state);

                        return false;
                    }
                }.bind(that);

                xhr.open("POST", '/listinginput/registration/VerifyUsernamePasswordCombo' + this.state.QueryString, false);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToSend));
            }
        }
        else {
            Spinner.Show($('#pagebody'), true);
            var that = this;

            //timeout allows for the spinner to show slightly, gives user a visual that the button click worked.
            setTimeout(function () {
                var objectToSend = {
                    Email: state.Email,
                    Password: state.Password,
                };

                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    var response = JSON.parse(xhr.response);
                    Spinner.Remove();

                    if (response.oContactModel.VerifyUserName) {
                        state.VerifyUserName = true;
                        state.HighlightErrors.Password = false;
                        state.InputErrors.Password = "";
                        that.handleFormUpdate(state);

                        $('.Username').fadeIn();
                        return false;
                    }
                    else if (response.oContactModel.EmailIsPaidBlock) {
                        state.HighlightErrors.Password = true;
                        state.InputErrors.Password = state.Translations["IncorrectCredentials"];
                        that.handleFormUpdate(state);
                        return false;
                    }
                    else if (response.nPasswordResetStatusID == 2) {
                        state.HighlightErrors.Email = true;
                        state.InputErrors.Email = state.Translations["TemporaryPasswordUsed"];
                        $('input[id="Password-Input"]').focus();
                    }
                    else if (response.oContactModel.CRMID > 0 || response.oContactModel.LeadCRMID > 0) {

                        //autofill the input fields
                        state.CRMID = response.oContactModel.CRMID;
                        state.EmailVerified = true;
                        state.LeadCRMID = response.oContactModel.LeadCRMID;
                        state.Company = response.oContactModel.Company;
                        state.Email = response.oContactModel.Email;
                        state.FirstName = response.oContactModel.FirstName;
                        state.LastName = response.oContactModel.LastName;
                        state.Phone = response.oContactModel.Phone;

                        // clear errors
                        state.HighlightErrors.Email = false;
                        state.InputErrors.Email = "";
                        state.HighlightErrors.FirstName = false;
                        state.HighlightErrors.LastName = false;
                        state.InputErrors.Name = "";
                        state.HighlightErrors.Phone = false;
                        state.InputErrors.Phone = "";
                        state.HighlightErrors.Password = false;
                        state.InputErrors.Password = "";

                        var loginLocation = response.oContactModel.LocationViewModel;
                        if (loginLocation.Country == "USA" && loginLocation.State.toUpperCase() != "CALIFORNIA" &&
                            state.ShowWeeklyUpdateSubscriptionCheckbox) {
                            state.ReceiveEmails = true;
                        }
                        else {
                            state.ReceiveEmails = false;
                        }

                        that.updateMasterLocation(loginLocation);
                        that.handleFormUpdate(state);
                        that.handleMasterUpdate(state);

                        $('#ContactLocationInfo').fadeIn();
                        $('#contact-phone').fadeIn();
                        $('#contact-name').fadeIn();
                        if (!this.state.IsRearrangedDetailsPage) {
                            $("#submit-section").hide();
                        }
                        $('#SubmitBtn').fadeIn();
                        $('#CreateAccountSection').hide();
                        $('#VerifyPasswordSection').hide();
                        $('#VerifyPasswordSaveAndExit').hide();
                        $("#saveExitMessage").hide();
                        $("#SavedFor30Days").hide();
                        $('#contact-email').hide();
                        $("#info-done-contact-btn").show();
                        $("#info-done-contact-btn").focus();

                        return true;
                    }
                    else {
                        state.HighlightErrors.Password = true;
                        state.InputErrors.Password = state.Translations["PasswordInvalid"];
                        that.handleFormUpdate(state);
                        setTimeout(() => {
                            const passwordInput = document.getElementById("Password-Input");
                            if (passwordInput) {
                                passwordInput.focus();
                            }
                        }, 0);
                        return false;
                    }
                }.bind(that);
                xhr.open("POST", '/listinginput/registration/VerifyEmailPasswordCombo', false);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToSend));
            }, 100);
        }

        if (this.state.IsRearrangedDetailsPage &&
            (state.HighlightErrors.Password || state.HighlightErrors.Email)) {
            OpenSpecificHeaderAccordion(ContactSectionID);
        }
    }

    IsRegisteredEmail(sEmail, bShowSpinner) {
        if (bShowSpinner)
            Spinner.Show($('#pagebody'), true);

        var state = this.state;
        var objectToSend = {
            Email: sEmail,
        };

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            if (bShowSpinner)
                Spinner.Remove();

            var response = JSON.parse(xhr.response);

            if (response.bIsPaidBlockUser) {
                state.HighlightErrors.Email = true;
                state.InputErrors.Email = state.Translations["IncorrectCredentials"];
                this.ClearForm();
            }
            else if (response.nPasswordResetStatusID == 2) {
                this.DisplayVerifyPasswordForm();
                state.HighlightErrors.Email = true;
                state.InputErrors.Email = state.Translations["TemporaryPasswordUsed"];
                $('input[id="Password-Input"]').focus();
            }
            else if (response.bIsRegisteredEmail) {
                this.DisplayVerifyPasswordForm();
                $('input[id="Password-Input"]').focus();
                state.HighlightErrors.Email = false;
                state.InputErrors.Email = "";
            }
            else {
                this.DisplayCreateAccount();
                state.HighlightErrors.Email = false;
                state.InputErrors.Email = "";
            }

            state.EmailIsRegistered = response.bIsRegisteredEmail;
            state.EmailIsPaidBlock = response.bIsPaidBlockUser;
            state.VerifyUserName = false;

            this.handleFormUpdate(state);

        }.bind(this);

        xhr.open("POST", '/listinginput/registration/VerifyEmailAddress' + this.state.QueryString, false);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));

        return state;
    }

    IsValidEmail(sEmail) {
        var returnModel;
        var objectToSend = {
            Email: sEmail,
        };

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            Spinner.Remove();
            var response = JSON.parse(xhr.response);
            if (response.model.DidYouMean != null) {
                $('#emailSuggestion').text(response.model.DidYouMean).val(response.model.DidYouMean);
                $('#emailSuggestionWrapper').fadeIn();
            }
            returnModel = response.model;
        }.bind(this);

        xhr.open("POST", '/listinginput/registration/ValidateEmail', false);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));

        return returnModel;
    }

    ClearForm() {
        var state = this.state;
        $('#contact-phone').fadeIn();
        $('#contact-name').fadeIn();
        $('#ContactLocationInfo').hide();
        $('#CreateAccountSection').hide();
        if (!this.state.IsRearrangedDetailsPage) {
            $('#SubmitBtn').hide();
        }
        $('#VerifyPasswordSection').hide();
        $('#VerifyPasswordSaveAndExit').hide();
        $("#saveExitMessage").text(this.getTranslation("saveExitMessageCreateAccount"));

        this.props.SaveAllSections(false, false);

        state.EmailIsRegistered = false;
        state.ValidatedEmail = "";
        state.Password = "";
        state.FirstName = "";
        state.LastName = "";
        state.Phone = "";

        this.handleFormUpdate(state);
    }

    DisplayCreateAccount() {
        $("#saveExitMessage").text(this.getTranslation("saveExitMessageCreateAccount"));
        //show password form & contact form, and hide others
        $('#ContactLocationInfo').fadeIn();
        $('#CreateAccountSection').fadeIn();
        $('#contact-phone').fadeIn();
        $('#contact-name').fadeIn();
        $('#PrivacyPolicy').fadeIn();
        $('#VerifyPasswordSection').hide();
        $('#VerifyPasswordSaveAndExit').hide();

        if (!$('#submit-section').is(":visible"))
            $('#SubmitBtn').fadeIn();
    }

    DisplayVerifyPasswordForm() {
        $("#saveExitMessage").text(this.getTranslation("saveExitMessageVerify"));
        setTimeout(() => {
            const passwordInput = document.getElementById("Password-Input");
            if (passwordInput) {
                passwordInput.focus();
            }
        }, 0);

        //show verify section and hide others
        $('#ContactLocationInfo').hide();
        $('#CreateAccountSection').hide();
        if (!this.state.IsRearrangedDetailsPage) {
            $('#SubmitBtn').hide();
        }
        $('#contact-phone').hide();
        $('#contact-name').hide();
        $('#PrivacyPolicy').hide();
        $('.Username').hide();

        if ($('#submit-section').is(":visible")) {
            $('#VerifyPasswordSaveAndExit').fadeIn();
        } else {
            $('#VerifyPasswordSection').show();
            $("#info-done-contact-btn").hide();
        }

        // if the user was trying to log in with OTP before
        if (this.state.ShowOTPForm) {
            $('#OTPVerificationForm').hide();

            this.setState({
                ShowOTPForm: false,
                OTPRegistrationLookupSuccess: false
            });

            // clear the OTP attempt from XML
            var xhr = new XMLHttpRequest();
            xhr.open("POST", '/listinginput/registration/ClearOTPVerificationAttemptFromXML' + this.state.QueryString, false);
            xhr.setRequestHeader("Content-type", "application/json");
            xhr.send();
        }
    }

    DisplayOTPVerificationForm() {
        $('#ContactLocationInfo').hide();
        $('#CreateAccountSection').hide();
        if (!this.state.IsRearrangedDetailsPage) {
            $('#SubmitBtn').hide();
        }
        $('#contact-phone').hide();
        $('#contact-name').hide();
        $('#PrivacyPolicy').hide();
        $('.Username').hide();
        $('#VerifyPasswordSection').hide();
        $('#VerifyPasswordSaveAndExit').hide();
        $('#info-done-contact-btn').hide();
        $('#OTPVerificationForm').fadeIn();
        this.setState({
            ShowOTPForm: true
        });
        setTimeout(() => {
            const emailUsername = document.getElementById("EmailOrUsername");
            if (emailUsername) {
                emailUsername.focus();
            }
        }, 0);
    }

    DisplayLoggedInForm() {
        $('#ContactLocationInfo').fadeIn();
        $('#contact-phone').fadeIn();
        $('#contact-name').fadeIn();
        $('#SubmitBtn').fadeIn();
        $('#CreateAccountSection').hide();
        $('#VerifyPasswordSection').hide();
        $('#VerifyPasswordSaveAndExit').hide();
        $("#saveExitMessage").hide();
        $("#SavedFor30Days").hide();
        $('#contact-email').hide();
        if (!this.state.IsRearrangedDetailsPage) {
            $("#submit-section").hide();
        }
        $('#OTPVerificationForm').hide();
    }

    PasswordStrength(sPassword) {
        if (!sPassword) {
            $(".PasswordInput").css("box-shadow", "");
            $("#PasswordStrength").css("color", "");
            $("#PasswordStrength").css("font-weight", "");
            $("#PasswordStrength").css("margin-left", "");
            $("#PasswordStrength").text("");
            return "";
        }
        else {
            var strength = 5;
            try {
                var checked = zxcvbn(sPassword);
                strength = checked.score;
            } catch (error) { }

            switch (strength) {
                case 0:
                case 1:
                    //return translated phrase: weak
                    $(".PasswordInput").css("box-shadow", "0 0 5px #B12C1B");
                    $("#PasswordStrength").css("color", "#B12C1B");
                    $("#PasswordStrength").css("font-weight", "bold");
                    $("#PasswordStrength").css("margin-left", "5px");
                    $("#PasswordStrength").text(this.getTranslation("Weak"));
                    return this.getTranslation("Weak");
                    break;
                case 2:
                    //return translated phrase: medium
                    $(".PasswordInput").css("box-shadow", "0 0 5px yellow");
                    $("#PasswordStrength").css("color", "#444444");
                    if (this.state.CurrentSite == "EquineMarket") {
                        $("#PasswordStrength").css("color", "#ffffff");
                    }
                    $("#PasswordStrength").css("font-weight", "bold");
                    $("#PasswordStrength").css("margin-left", "5px");
                    $("#PasswordStrength").text(this.getTranslation("Medium"));
                    return this.getTranslation("Medium");
                    break;
                case 3:
                case 4:
                    //return translated phrase: strong
                    $(".PasswordInput").css("box-shadow", "0 0 5px green");
                    $("#PasswordStrength").css("color", "green");
                    $("#PasswordStrength").css("font-weight", "bold");
                    $("#PasswordStrength").css("margin-left", "5px");
                    $("#PasswordStrength").text(this.getTranslation("Strong"));
                    return this.getTranslation("Strong");
                    break;
                default:
                    $(".PasswordInput").css("box-shadow", "");
                    $("#PasswordStrength").css("color", "");
                    $("#PasswordStrength").css("font-weight", "");
                    $("#PasswordStrength").css("margin-left", "");
                    $("#PasswordStrength").text("");
                    break;
            }
        }
    }

    PasswordMatch(sPassword, sRetypedPassword) {
        //if passwords don't match, highlight
        if (sRetypedPassword != sPassword && sRetypedPassword != "" && sPassword != "") {
            $("#ReTypePasswordMatch").css("color", "#B12C1B");
            $("#ReTypePasswordMatch").css("font-weight", "bold");
            $("#ReTypePasswordMatch").css("margin-left", "5px");
            $("#ReTypePasswordMatch").text(this.getTranslation("NoMatch"));
        }
        else if (sRetypedPassword != "" && sPassword != "") {
            //there's a match
            $("#ReTypePasswordMatch").css("color", "green");
            $("#ReTypePasswordMatch").css("font-weight", "bold");
            $("#ReTypePasswordMatch").css("margin-left", "5px");
            $("#ReTypePasswordMatch").text(this.getTranslation("PasswordsMatch"));
        }
        else {
            $("#ReTypePasswordMatch").css("color", "");
            $("#ReTypePasswordMatch").css("font-weight", "");
            $("#ReTypePasswordMatch").css("margin-left", "");
            $("#ReTypePasswordMatch").text("");
        }
    }

    showPrivacyModal() {
        $("body").addClass("lock");
        $("#privacy-modal").show();
        $("#privacy-continue-btn").focus()
    }

    submitForm(e) {
        if (e) {
            e.preventDefault();
        }
        var state = this.state;

        if (state.bIsExitNewUser) {
            this.props.SaveAllSections(false, true);
            var that = this;
            setTimeout(function () {
                //make sure there is no errors anywhere else in the form
                var bNoErrors = that.validatorContact(state, true);

                if (bNoErrors) {
                    //create account 
                    var objectToSend = {
                        Email: state.Email,
                        ReceiveEmails: state.ReceiveEmails,
                        FirstName: state.FirstName,
                        LastName: state.LastName,
                        Phone: state.Phone,
                        Company: state.Company,
                        EmailIsRegistered: state.EmailIsRegistered,
                        LocationViewModel: that.getMasterLocation(),
                        Password: state.Password,
                        UnfinishedLeadNewPartialCRMID: state.UnfinishedLeadNewPartialCRMID
                    };

                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                        var response = JSON.parse(xhr.response);

                        if (response.oUser.CRMID > 0) {
                            Spinner.Remove();

                            //set the new CRMID so that it can get passed into the submit
                            state.CRMID = response.oUser.CRMID;
                            state.Password = response.oUser.Password;
                            state.ReEnterPassword = response.oUser.Password;
                            $("#CreateAccountSection").fadeOut();
                            that.handleFormUpdate(state);

                            //We've created an account. Log them in.
                            window.location = response.oUser.Message;
                        }
                        else {
                            //account not created. Show errors. prob password not strong enough
                            Spinner.Remove();
                            $("#submissionError").text(response.oUser.Message);
                            $("#submissionError").show();
                        }
                    }.bind(that);

                    xhr.open("POST", '/listinginput/registration/CreateAccount' + that.state.QueryString, false);
                    xhr.setRequestHeader("Content-type", "application/json");
                    xhr.send(JSON.stringify(objectToSend));
                }
                else {
                    //show the error to the user
                    Spinner.Remove();
                }
            }, 100);
        }
        else {
            this.props.SaveAllSections();
            if (state.IsRegisteredUser || state.EmailVerified) {
                this.props.submitListing();
            }
            else {
                //create account. This is done in a Javascript file so that recaptch can be used. Recaptcha needs to call a javascript method and cannot communicate with react states.
                state.ExcludeGoodsAndServicesTax = this.props.masterViewModel.PriceViewModel.ExcludeGoodsAndServicesTax;
                CreateAccount(state);
            }
        }
    }

    //shoots off to SSO SignIn Get method. That method will return to our page after the Facebook login. 
    facebookLogin() {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/listinginput/registration/FacebookLogin' + this.state.QueryString, false);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(this.state.QueryString));

        var returnUrl = encodeURIComponent(window.location.href);
        var url = this.props.masterViewModel.SecureDomainURL + "sso/login?to=" + returnUrl + "&fbl=1";
        window.location = url;
    }

    //shoots off to SSO SignIn Get method. That method will return to our page after the Google login. 
    googleLogin() {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/listinginput/registration/GoogleLogin' + this.state.QueryString, false);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(this.state.QueryString));

        var returnUrl = encodeURIComponent(window.location.href);
        var url = this.props.masterViewModel.SecureDomainURL + "sso/login?to=" + returnUrl + "&gli=1";
        window.location = url;
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    //render
    render() {

        var submitAction = "";
        if (this.state.EmailIsRegistered && !this.state.EmailVerified) {
            submitAction = "login";
        }
        else {
            submitAction = "submit";
        }

        var saveAction = "";
        if (this.state.EmailIsRegistered) {
            saveAction = "exitVerify";
        }
        else {
            saveAction = "exitNewUser";
        }

        //logic to display if a logged in user should have the Receive Weekly Updates logic.
        var WeeklyUpdateCheckboxForLoggedInUser = [];
        if (this.state.ShowWeeklyUpdateSubscriptionCheckbox && (this.state.IsRegisteredUser || !this.state.EmailIsRegistered || this.state.EmailVerified)) {
            WeeklyUpdateCheckboxForLoggedInUser.push(
                <div id="ReceiveWeeklyUpdateEmails" key="ReceiveWeeklyUpdateEmails" style={{ margin: '20px 0px 20px 0px' }}>
                    <TextField
                        id="ReceiveEmails"
                        className=""
                        type="checkbox"
                        value={this.state.ReceiveEmails}
                        onFieldChanged={(e) => { this.handleFieldChanged("ReceiveEmails", e); }}
                        inline={true}
                        error={this.state.HighlightErrors.ReceiveEmails}
                        errorText={this.state.InputErrors.ReceiveEmails}
                        hasLabel={true}
                    />
                    <div dangerouslySetInnerHTML={{ __html: '<label for="ReceiveEmails">' + this.state.Translations["ReceiveEmails"] + '</label>' }} style={{ display: 'inline' }} />
                </div>
            );
        }
        var AuctionTimePhotoAgreement = [];
        if (this.state.CurrentSite == "AuctionTime" || this.state.CurrentSite == "AuctionValues") {
            AuctionTimePhotoAgreement.push(
                <div key="auctionTimePhotoAgreement" id="PhotoAgreement" style={{ padding: '20px 0px' }}>
                    <span>
                        <span style={{ color: '#D01313' }}>*</span>
                        {this.getTranslation("AuctionTimePhotoAgreement")}
                    </span>
                    <div className="validationError"><span></span></div>
                </div>
            );
        }

        let byContinuingYouAgree = [];
        let byClickingRegister = [];
        if (this.state.IsInTranslationEditorMode) {
            if (this.state.ShowFacebookLoginButton || this.state.ShowGoogleLoginButton) {
                byContinuingYouAgree.push(<div key="continuing-you-agree" style={{ textAlign: 'center', margin: '20px 0px 20px 0px' }}>{this.getTranslation("ByRegisteringWithThirdParty")} {this.getTranslation("termsofuse")} {this.getTranslation("PrivacyPolicy")} {this.getTranslation("CAPrivacyPolicyStatement")} {this.getTranslation("NoticeAtCollection")} {this.getTranslation("ByRegisteringWithThirdParty2")}</div>);
            }
            byClickingRegister.push(<p key="by-clicking-register" style={{ textAlign: 'center' }}>{this.getTranslation("ByClickingSubmitMyAd")} {this.getTranslation("SubmitMyAd")} {this.getTranslation("termsofuse")} {this.getTranslation("ByClickingSubmitMyAd2")}</p>);
        }
        else {
            if (this.state.ShowFacebookLoginButton || this.state.ShowGoogleLoginButton) {
                byContinuingYouAgree.push(<div key="continuing-you-agree" style={{ textAlign: 'center', margin: '20px 0px 20px 0px' }} dangerouslySetInnerHTML={{ __html: this.getTranslation("ByRegisteringWithThirdParty") + " " + this.state.CAPrivacyPolicyNotice + " " + this.getTranslation("ByRegisteringWithThirdParty2") }}></div>);
            }
            byClickingRegister.push(<p key="by-clicking-register" style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: this.getTranslation("ByClickingSubmitMyAd") }}></p>);
        }

        let MediaOverrideModal =
            <div className="modal" id="media-override-modal" onKeyDown={(e) => { if (e.key === 'Escape') CloseModal(); }}>
                <div className="modal-content">
                    <div className="modal-head">
                        <h2>{this.getTranslation("MediaOverride")}</h2>
                        <span className="close" onClick={(e) => { CloseModal(); }}><i className="fa fa-times" aria-hidden="true"></i></span>
                    </div>
                    <div className="modal-main" style={{ textAlign: 'center' }}>
                        <p>{this.getTranslation("InProgressUploadsWillBeDeleted")}</p>
                        <button type="button" role="link" tabIndex="0" id="media-override-continue-btn" className="landing-page-btn PrimaryBGC" onClick={(e) => { CloseModal(); this.handleButtonClick("submit", true); }}>{this.getTranslation("Continue")}</button>
                    </div>
                </div>
            </div>

        let PrivacyModal =
            <div className="modal" id="privacy-modal" onClick={(e) => { CloseModal(); }} onKeyDown={(e) => { if (e.key === 'Escape') CloseModal(); $("#PrivacyBtn").focus() }}>
                <div className="modal-content">
                    <div className="modal-head">
                        <h2 style={{ maxWidth: '97%' }}>{this.getTranslation("ProtectInfo")}</h2>
                        <span style={{ marginLeft: '25px' }} className="close" onClick={(e) => { CloseModal(); }}><i className="fa fa-times" aria-hidden="true"></i></span>
                    </div>
                    <div className="modal-main">
                        <p style={{ marginBottom: '10px' }}>{this.getTranslation("SecureContactOptions")}</p>

                        <ul style={{ margin: '0px 30px' }}>
                            <li>{this.getTranslation("CallsRouted")}</li>
                            <li>{this.getTranslation("SecureEmail")}</li>
                        </ul>
                        <button type="button" role="link" tabIndex="0" id="privacy-continue-btn" className="landing-page-btn PrimaryBGC" style={{ margin: '25px auto' }} onClick={(e) => { CloseModal(); $("#PrivacyBtn").focus() }}>{this.getTranslation("Continue")}</button>
                    </div>
                </div>
            </div>

        {/* Facebook Login */ }
        let FacebookLoginButton =
            <button type="button" className="facebook-btn" onClick={(e) => { this.facebookLogin(); }}>
                <i className="fa fa-facebook-official" style={{ paddingRight: '11px' }}></i>
                {this.getTranslation("LoginWithFacebook")}
            </button>;

        {/* Google Login */ }
        let GoogleLoginButton =
            <button type="button" className="google-btn" onClick={(e) => { this.googleLogin(); }}>
                <i className="fa fa-google" style={{ paddingRight: '11px' }}></i>
                {this.getTranslation("SigninWithGoogle")}
            </button>;

        {/* OTP Login */ }
        let OTPLoginButton =
            <button
                type="button"
                className="otp-btn PrimaryBGC siteFontColor preserveDefaultBehaviorWithTranslationEditor"
                style={this.state.ShowFacebookLoginButton || this.state.ShowGoogleLoginButton ? {} : { marginBottom: "20px" }}
                onClick={(e) => { this.DisplayOTPVerificationForm(); $("#EmailOrUsername").focus() }}>
                {this.getTranslation("LoginWithEmailOrTextVerification")}
            </button>;

        let OTPElements = [];
        if (this.state.ShowOTPForm && !this.state.OTPRegistrationLookupSuccess) {
            // show OTP search for registration button
            OTPElements.push(
                <button type="button" role="link" className="otpFormBtn PrimaryBGC siteFontColor preserveDefaultBehaviorWithTranslationEditor" onClick={(e) => { this.handleButtonClick("SearchRegistrationForOTPVerification"); $("#OTPVerificationOptions").focus() }} >{this.getTranslation("SearchForRegistrationToSendCode")}</button>
            );
        }
        else if (this.state.ShowOTPForm && this.state.OTPRegistrationLookupSuccess && !this.state.OTPCodeSent) {
            // show options for sending OTP code
            let radios = [];
            radios.push({ text: this.getTranslation("SendAnEmailTo") + ": " + "<span style='font-weight:bold;'>" + this.state.EmailForOTPVerification + "</span>", value: 0 });
            if (this.state.PhoneForOTPVerification != null && this.state.PhoneForOTPVerification != "") {
                radios.push({ text: this.getTranslation("SendATextToTheNumberEndingIn") + ": " + "<span style='font-weight:bold;'>" + this.state.PhoneForOTPVerification + "</span>", value: 1 });
            }
            if (this.state.AltPhoneForOTPVerification != null && this.state.AltPhoneForOTPVerification != "") {
                radios.push({ text: this.getTranslation("SendATextToTheNumberEndingIn") + ": " + "<span style='font-weight:bold;'>" + this.state.AltPhoneForOTPVerification + "</span>", value: 2 });
            }

            OTPElements.push(
                <RadioField
                    feRequired={false}
                    id="OTPVerificationOptions"
                    disabled={false}
                    radios={radios}
                    value={this.state.SelectedVerificationMethod}
                    isvertical={false}
                    onFieldChanged={(e) => { this.handleFieldChanged("SelectedVerificationMethod", e); }}
                    style={{ padding: "0px 0px 15px 0px", height: "auto", border: "0px" }}
                />
            );
            OTPElements.push(
                <button type="button" id="send-code-btn" role="link" className="otpFormBtn PrimaryBGC siteFontColor preserveDefaultBehaviorWithTranslationEditor" onClick={(e) => { this.handleButtonClick("SendCodeForOTPVerification"); }} >{this.getTranslation("SendCode")}</button>
            );
        }
        else if (this.state.ShowOTPForm && this.state.OTPRegistrationLookupSuccess && this.state.OTPCodeSent) {
            // show verification code input and login button
            OTPElements.push(
                <div className="form-row cf verification-code" style={{ width: "100%" }}>
                    <label className="label-left" htmlFor="Verification-Code" style={{ fontSize: "13px" }}>{this.getTranslation("VerificationCode")} <span>*</span></label>
                    <div className="input-right">
                        <TextField
                            id="Verification-Code"
                            type="number"
                            value={this.state.OTPVerificationCode}
                            onFieldChanged={(e) => { this.handleFieldChanged("OTPVerificationCode", e); }}
                            handleKeyDown={(e) => { this.handleButtonClick("ValidateCodeForOTPVerification"); }}
                            error={this.state.HighlightErrors.OTPVerificationCode}
                            errorText={this.state.InputErrors.OTPVerificationCode}
                            hasLabel={true}
                        />
                    </div>
                </div>
            );
            OTPElements.push(
                <button type="button" id="log-in-btn" role="link" className="otpFormBtn PrimaryBGC siteFontColor preserveDefaultBehaviorWithTranslationEditor" onClick={(e) => { this.handleButtonClick("ValidateCodeForOTPVerification"); }} >{this.getTranslation("LogIn")}</button>
            );
        }

        let emailOrUsername = [];

        const privacyText = this.getTranslation("YourPrivacyMatters");
        let privacyStringParts = splitStringAtFirstOccurrence(privacyText, "!");
        if (privacyText.indexOf("!") === -1) {
            privacyStringParts = splitStringAtFirstOccurrence(privacyText, ".");
        }

        // don't show the email input if we are showing the OTP verification code prompt, show email or username input instead
        if (!(this.state.OTPRegistrationLookupSuccess && this.state.OTPCodeSent)) {
            if (this.state.ShowOTPForm) {
                emailOrUsername.push(
                    <label key="EmailOrUsernameLabel" className="label-left" htmlFor="EmailOrUsername">{this.getTranslation("EmailOrUsername")} <span>*</span></label>
                );
                emailOrUsername.push(
                    <div className="input-right" key="EmailOrUsername">
                        <TextField
                            id="EmailOrUsername"
                            value={this.state.EmailOrUsername == "" ? this.state.Email : this.state.EmailOrUsername}
                            onFieldChanged={(e) => { this.handleFieldChanged("EmailOrUsername", e); }}
                            onBlur={(e) => { this.handleOnBlur("EmailOrUsername", e); }}
                            handleKeyDown={(e) => { !this.state.OTPRegistrationLookupSuccess ? this.handleButtonClick("SearchRegistrationForOTPVerification") : null; }}
                            error={this.state.HighlightErrors.EmailOrUsername}
                            errorText={this.state.InputErrors.EmailOrUsername}
                            hasLabel={true}
                        />
                    </div>
                );
            }
            else {
                emailOrUsername.push(
                    <label className="label-left" htmlFor="Email" key="EmailLabel">{this.getTranslation("Email")}<span>*</span></label>
                );
                emailOrUsername.push(
                    <div className="input-right" key="Email">
                        <TextField
                            id="Email"
                            value={this.state.Email == "" ? this.state.EmailOrUsername : this.state.Email}
                            onFieldChanged={(e) => { this.handleFieldChanged("Email", e); }}
                            onBlur={(e) => { this.handleOnBlur("Email", e); }}
                            error={this.state.HighlightErrors.Email}
                            errorText={this.state.InputErrors.Email}
                            hasLabel={true}
                        />
                        {this.state.IsInTranslationEditorMode ?
                            <div id="emailSuggestionWrapper" style={{ display: 'none', fontWeight: 'bold', color: '#ff0000' }}>{this.getTranslation("SuggestedEmail")}<span id='emailSuggestion' onClick={(e) => { this.handleButtonClick("SuggestedEmail", e); }} style={{ cursor: 'pointer', color: 'Black' }}></span>?</div>
                            :
                            <div id="emailSuggestionWrapper" style={{ display: 'none', fontWeight: 'bold', color: '#ff0000' }}>{(this.state.Translations["SuggestedEmail"]).replace("{0}?", " ")}<span id='emailSuggestion' onClick={(e) => { this.handleButtonClick("SuggestedEmail", e); }} style={{ cursor: 'pointer', color: 'Black' }}></span>?</div>
                        }
                    </div>
                );
            }
        }

        return (
            <form id="regform" onSubmit={this.submitForm}>
                <div className="accordion cf"
                    id="accordion-content-3"
                    style={!this.state.IsRearrangedDetailsPage ? undefined : { paddingTop: '0px' }}
                >

                    {this.state.IsRearrangedDetailsPage ? (
                        <div style={{ marginBottom: "10px" }}>
                            <h2>{this.getTranslation("BuyersReachYou")}</h2>
                            <div>
                                <strong>{privacyStringParts.before} </strong>
                                <i>{privacyStringParts.after} </i>
                                <button tabIndex="0" type="button" className="inLblLinkBlue" id="PrivacyBtn" style={{ color: "black" }} onClick={(e) => { e.preventDefault(); this.showPrivacyModal() }}>{this.getTranslation("LearnMore")}</button>
                            </div>
                        </div>
                    ) : (
                        <div style={{ marginBottom: "10px" }}>
                            <strong>{privacyStringParts.before} </strong>
                            <i>{privacyStringParts.after} </i>
                            <button tabIndex="0" type="button" className="inLblLinkBlue" id="PrivacyBtn" style={{ color: "black" }} onClick={(e) => { e.preventDefault(); this.showPrivacyModal() }}>{this.getTranslation("LearnMore")}</button>
                        </div>
                    )}

                    <div className="error-message" id="saveExitMessage" style={{ display: 'none' }}></div>
                    <div className="error-message" id="SavedFor30Days" style={{ display: 'none' }}>{this.getTranslation("SavedFor30Days")}</div>

                    <div className="validationError" style={{ textAlign: 'center' }}>
                        <span>{this.state.InputErrors.LeadPromotion}</span>
                    </div>

                    {/*Email*/}
                    <div className="form-row cf" id="contact-email">
                        {OTPLoginButton}
                        {this.state.ShowFacebookLoginButton && FacebookLoginButton}
                        {this.state.ShowGoogleLoginButton && GoogleLoginButton}
                        {byContinuingYouAgree}
                        {emailOrUsername}
                    </div>

                    {/*Name*/}
                    <div className="form-row cf" id="contact-name">
                        <label className="label-left" htmlFor="FirstName" id="NameLabel" htmlFor="FirstName">{this.getTranslation("Name")}<span>*</span></label>
                        <div className="input-right" id="ContactName">
                            <TextField
                                id="FirstName"
                                value={this.state.FirstName}
                                className={"half-input"}
                                onFieldChanged={(e) => { this.handleFieldChanged("FirstName", e); }}
                                onBlur={(e) => { this.handleOnBlur("FirstName", e); }}
                                SmallInput={true}
                                placeholder={this.state.Translations["FirstName"]}
                                error={this.state.HighlightErrors.FirstName}
                                hasLabel={true}
                                ariaLabelledBy="NameLabel"
                            />
                            <TextField
                                id="LastName"
                                value={this.state.LastName}
                                className={"half-input"}
                                onFieldChanged={(e) => { this.handleFieldChanged("LastName", e); }}
                                onBlur={(e) => { this.handleOnBlur("LastName", e); }}
                                SmallInput={true}
                                placeholder={this.state.Translations["LastName"]}
                                error={this.state.HighlightErrors.LastName}
                                hasLabel={true}
                                ariaLabelledBy="NameLabel"
                            />
                            <div className="validationError">
                                <span>{this.state.InputErrors.Name}</span>
                            </div>
                        </div>
                    </div>

                    {/*Phone*/}
                    <div className="form-row cf" id="contact-phone">
                        <label className="label-left" htmlFor="Phone">{this.getTranslation("Phone")}<span>*</span></label>
                        <div className="input-right">
                            <TextField
                                type="tel"
                                id="Phone"
                                value={this.state.Phone}
                                onFieldChanged={(e) => { this.handleFieldChanged("Phone", e); }}
                                onBlur={(e) => { this.handleOnBlur("Phone", e); }}
                                error={this.state.HighlightErrors.Phone}
                                errorText={this.state.InputErrors.Phone}
                                hasLabel={true}
                            />
                        </div>
                    </div>

                    {/*VerifyPassword*/}
                    <div id="VerifyPasswordSection" style={{ display: 'none' }}>
                        <div className="Username" style={{ display: 'none' }}>
                            <div style={{ textAlign: 'center' }} className="validationError">{this.getTranslation("UseUsername")}</div>
                            <div className="fe-section cf">
                                <div className="form-row cf">
                                    <label className="label-left" htmlFor="Username">{this.getTranslation("Username")} <span>*</span></label>
                                    <div className="input-right">
                                        <TextField
                                            id="Username"
                                            value={this.state.Username}
                                            onFieldChanged={(e) => { this.handleFieldChanged("Username", e); }}
                                            handleKeyDown={(e) => { this.handleButtonClick("login"); }}
                                            error={this.state.HighlightErrors.Username}
                                            errorText={this.state.InputErrors.Username}
                                            hasLabel={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign: 'center' }}>{this.getTranslation("WelcomeBack")}</div>
                        <div className="fe-section cf">
                            <div className="form-row cf category-input password">
                                <label className="label-left" htmlFor="Password-Input">{this.getTranslation("Password")} <span>*</span></label>
                                <div className="input-right">
                                    <TextField
                                        id="Password-Input"
                                        type="password"
                                        value={this.state.Password}
                                        onFieldChanged={(e) => { this.handleFieldChanged("Password", e); }}
                                        handleKeyDown={(e) => { this.handleButtonClick("login"); }}
                                        error={this.state.HighlightErrors.Password}
                                        errorText={this.state.InputErrors.Password}
                                        hasLabel={true}
                                    />
                                </div>
                            </div>
                            <button type="button" role="link" id="login-btn" className="all-cats PrimaryBGC siteFontColor preserveDefaultBehaviorWithTranslationEditor" onClick={(e) => { this.handleButtonClick("login"); }} style={{ fontSize: '16px !important' }}> {this.getTranslation("Verify")}</button>
                            <div style={{ textAlign: 'center' }}>
                                <button type="button" role="link" className="tip-text" onClick={(e) => { this.handleButtonClick("reset"); }}>{this.getTranslation("ResetPassword")}</button>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <p className="label" id="ResetPasswordEmailSuccess" style={{ display: 'none', fontWeight: 'bold', textAlign: 'center' }}>{this.getTranslation("ResetPasswordSuccess")}</p>
                                <p className="error-message" id="ResetPasswordEmailError" style={{ display: "none" }}>{this.getTranslation("ResetPasswordError")}</p>
                            </div>
                        </div>
                    </div>

                    {/*VerifyPassword for Save and Exit*/}
                    <div id="VerifyPasswordSaveAndExit" style={{ display: 'none' }}>
                        <div className="Username" style={{ display: 'none' }}>
                            <div style={{ textAlign: 'center' }} className="validationError">{this.getTranslation("UseUsername")}</div>
                            <div className="fe-section cf">
                                <div className="form-row cf">
                                    <label className="label-left" htmlFor="Username-Exit">{this.getTranslation("Username")} <span>*</span></label>
                                    <div className="input-right">
                                        <TextField
                                            id="Username-Exit"
                                            value={this.state.Username}
                                            onFieldChanged={(e) => { this.handleFieldChanged("Username", e); }}
                                            handleKeyDown={(e) => { this.handleButtonClick("login"); }}
                                            error={this.state.HighlightErrors.Username}
                                            errorText={this.state.InputErrors.Username}
                                            hasLabel={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign: 'center' }}>{this.getTranslation("WelcomeBack")}</div>
                        <div className="fe-section cf">
                            <div className="form-row cf password" style={{ marginBottom: '0px' }}>
                                <label className="label-left" htmlFor="Password-Input-Exit">{this.getTranslation("Password")} <span>*</span></label>
                                <div className="input-right">
                                    <TextField
                                        id="Password-Input-Exit"
                                        type="password"
                                        value={this.state.Password}
                                        onFieldChanged={(e) => { this.handleFieldChanged("Password", e); }}
                                        error={this.state.HighlightErrors.Password}
                                        errorText={this.state.InputErrors.Password}
                                        hasLabel={true}
                                    />
                                </div>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <button type="button" role="link" className="tip-text" onClick={(e) => { this.handleButtonClick("reset"); }}>{this.getTranslation("ResetPassword")}</button>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <p className="label" id="ResetPasswordEmailSuccess-Exit" style={{ display: 'none', fontWeight: 'bold', textAlign: 'center' }}>{this.getTranslation("ResetPasswordSuccess")}</p>
                                <p className="error-message" id="ResetPasswordEmailError-Exit" style={{ display: "none" }}>{this.getTranslation("ResetPasswordError")}</p>
                            </div>
                        </div>
                    </div>

                    {/* OTP Buttons */}
                    <div id="OTPVerificationForm" className="fe-section cf" style={{ display: "none" }}>
                        {OTPElements}
                        <p style={{ margin: "0px" }} >{this.getTranslation("Or")}</p>
                        <button type="button" role="link" id="otp-login-btn" className="otpFormBtn PrimaryBGC siteFontColor preserveDefaultBehaviorWithTranslationEditor" onClick={(e) => { this.DisplayVerifyPasswordForm(); $("#Password-Input").focus(); }} >{this.getTranslation("LoginWithPassword")}</button>
                    </div>

                    {/*Contact Info*/}
                    <div id="ContactLocationInfo" style={{ display: 'none' }}>

                        {/*Company*/}
                        <div className="form-row cf">
                            <label className="label-left" htmlFor="Company">{this.getTranslation("Company")}</label>
                            <div className="input-right">
                                <TextField
                                    id="Company"
                                    value={this.state.Company}
                                    onFieldChanged={(e) => { this.handleFieldChanged("Company", e); }}
                                    onBlur={(e) => { this.handleOnBlur("Company", e); }}
                                    error={this.state.HighlightErrors.Company}
                                    errorText={this.state.InputErrors.Company}
                                    hasLabel={true}
                                />
                            </div>
                        </div>
                    </div>

                    {/*CreateAccount*/}

                    {!this.state.IsRearrangedDetailsPage ? (
                        <>
                            <div id="CreateAccountSection" style={{ display: 'none' }}>
                                <h2>{this.getTranslation("CreateAccount")}</h2>
                                <div className="tip-text" style={{ paddingBottom: '20px' }}>
                                    <span style={{ display: 'block' }}>{this.getTranslation("PasswordText1")}</span>
                                    <span style={{ display: 'block' }}>{this.getTranslation("PasswordText2")}</span>
                                    <span style={{ display: 'block' }}>{this.getTranslation("PasswordText3")}</span>
                                </div>
                                <div className="form-row cf">
                                    <label className="label-left" htmlFor="Password-Input-Create">{this.getTranslation("Password")}</label>
                                    <div className="input-right">
                                        <TextField
                                            id="Password-Input-Create"
                                            type="password"
                                            value={this.state.Password}
                                            className="PasswordInput"
                                            onFieldChanged={(e) => { this.handleFieldChanged("Password", e); }}
                                            onBlur={(e) => { this.handleOnBlur("checkPassword", e); }}
                                            error={this.state.HighlightErrors.Password}
                                            errorText={this.state.InputErrors.Password}
                                            hasLabel={true}
                                        />
                                        <div className="label" id="PasswordStrength"></div>
                                    </div>
                                </div>

                                <div className="form-row cf">
                                    <label className="label-left" htmlFor="ReEnterPassword">{this.getTranslation("ReEnterPassword")}</label>
                                    <div className="input-right">
                                        <TextField
                                            id="ReEnterPassword"
                                            type="password"
                                            value={this.state.ReEnterPassword}
                                            onFieldChanged={(e) => { this.handleFieldChanged("ReEnterPassword", e); }}
                                            error={this.state.HighlightErrors.ReEnterPassword}
                                            errorText={this.state.InputErrors.ReEnterPassword}
                                            hasLabel={true}
                                        />
                                        <div className="label" id="ReTypePasswordMatch"></div>
                                    </div>
                                </div>
                            </div>

                            {/*Submit*/}
                            <div className="error-message" id="submissionError" style={{ display: 'none' }}></div>

                            {WeeklyUpdateCheckboxForLoggedInUser}

                            <div id="SubmitBtn" style={{ display: 'none' }}>
                                { /* Auction Time Photo legal text*/}
                                {AuctionTimePhotoAgreement}
                                {byClickingRegister}
                                <button type="button" role="link" id="submit-btn" className="submit-btn PrimaryBGC siteFontColor" onClick={(e) => { this.handleButtonClick("submit"); }}>{this.getTranslation("SubmitAd")}</button>
                            </div>
                            <div id="submit-section" style={{ textAlign: 'center', display: ' none' }}>
                                {byClickingRegister}
                                <button type="button" role="link" className="contact-btn save-exit-btn" onClick={(e) => { this.handleButtonClick(saveAction); }}>{this.getTranslation("SaveAndExit")}</button>
                                <button type="button" role="link" className="contact-btn" onClick={(e) => { this.handleButtonClick(submitAction); }}>{this.getTranslation("SubmitAd")}</button>
                            </div>
                        </>
                    ) :
                        <button role="link" className="form-btn" id="info-done-contact-btn" onClick={(e) => { e.preventDefault(); this.handleButtonClick("done"); }} onMouseUp={(e) => { this.handleButtonClick("done"); }}>{this.getTranslation("DoneWithContactInfo")}</button>
                    }
                </div>
                {MediaOverrideModal}
                {PrivacyModal}
            </form>
        );
    }
}

export default ContactSection;
global.ContactSection = ContactSection;